<div class="d-flex w-100 h-100">
	<div class="mx-auto my-auto display-10">Thanks! Your order is being sent to the kitchen.</div>
</div>
